import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../../shared/shared.module';
import {MatDividerModule} from '@angular/material/divider';
import {MatDialogModule} from '@angular/material/dialog';
import {RedirectionDialogComponent} from './redirection-dialog.component';
import {IconsModule} from '../../icons/icons.module';


@NgModule({
  declarations: [RedirectionDialogComponent],
  imports: [
    CommonModule,
    SharedModule,
    MatDividerModule,
    MatDialogModule,
    IconsModule
  ]
})
export class RedirectionDialogModule {
}
